"use client";

import { useCallback, useState, useEffect } from "react";
import { signIn } from "next-auth/react";
import { useRouter } from "next/navigation";

export default function Login() {
  const router = useRouter();
  const [isMaintenance, setIsMaintenance] = useState(false);

  useEffect(() => {
    fetch("/api/maintenance")
      .then((r) => r.json())
      .then((d) => setIsMaintenance(!!d.mode))
      .catch(() => setIsMaintenance(false));
  }, []);

  const handleLogin = useCallback(() => {
    if (isMaintenance) {
      // Si el usuario hace clic en el botón, también lo redirigimos
      router.push("/maintenance");
      return;
    }
    // Si NO hay mantenimiento, procedemos con el inicio de sesión
    signIn("keycloak", { callbackUrl: "/register" });
  }, [isMaintenance, router]);

  return (
    <div className="w-full">
      <div className="flex w-full items-center justify-start">
        <button
          type="button"
          onClick={handleLogin}
          className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-xl bg-blue-800 px-5 py-3 text-white font-semibold shadow-sm transition
                       hover:bg-blue-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2"
        >
          Login
        </button>
      </div>
    </div>
  );
}
